module.exports = __webpack_public_path__ + "static/media/rectangleOnPlane1.1b754808.svg";